import { callService } from "../tools";

export const cargarReembolsos = (polizas) => {
	return dispatch => {  
		let llamadaSeguro = new callService({
			service: "siniestrosReembolsos.listaSiniestros",
			"secure": true,
			data: {polizas: polizas}
		}).execute().then(body=>{
			console.log(body);
			dispatch({
				"type": "SINIESTROS_SET_SINIESTROSREM",
				"sreembolsos": body
			});
		}).catch(error => {
			console.log(error);
			dispatch({ 
				"type": "MODAL_ALERT_MESSAGES_SHOW", 
				"titulo": "Error", 
				"mensaje" : "Hubo un error al obtener los siniestros de reembolsos. Favor de intentar más tarde." 
			});
		});
	};
};

export const cargarSiniestros = (polizas) => {
	return dispatch => {
		let llamadaSeguro = new callService({
			service: "siniestrosReparacion.listaSiniestros",
			"secure": true,
			data: {polizas: polizas}
		}).execute().then(body=>{
			console.log(body);
			dispatch({
				"type": "SINIESTROS_SET_SINIESTROSREP",
				"sreparacion": body.payload
			});
		}).catch(error => {
			console.log(error);
			dispatch({ 
				"type": "MODAL_ALERT_MESSAGES_SHOW", 
				"titulo": "Error", 
				"mensaje" : "Hubo un error al obtener los siniestros. Favor de intentar más tarde." 
			});
		});
	};
};

export const detalleSiniestro = (codSiniestro) => {
	return dispatch => {
		let llamadaSeguro = new callService({
			service: "siniestrosReparacion.consultaSiniestro",
			"secure": true,
			data: {siniestro: codSiniestro}
		}).execute().then(body=>{
			console.log(body);
			dispatch({
				"type": "SINIESTROS_SET_DETALLE_SINIESTROREP",
				"detalle": body.payload
			});
		}).catch(error => {
			console.log(error);
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : "Hubo un error al obtener el siniestro seleccionado. Favor de intentar más tarde." 
				  });
		});
	};
};



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/seguimiento.act.js